<template>
    <div id="app">
        <Header />
        <Navbar />
        <div class="body-section">
            <router-view />
        </div>
        <Footer />
    </div>
</template>

<script>
    import Vue from 'vue'
    import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

    import Header from '@/components/general/header.vue'
    import Navbar from '@/components/general/navbar.vue'
    import Footer from '@/components/general/footer.vue'

    Vue.use(BootstrapVue)
    Vue.use(IconsPlugin)

    import './custom.scss'

    export default {
        name: 'app',
        components: {
            Header,
            Navbar,
            Footer
        }
    }
</script>

<style>
    :root {
        --brown: #c89600;
        --darkbrown: #654321;
        --lightbrown: #e1dd00;
        --darkgray: #343a40;
    }

    html,
    body {
        margin: 0;
        position: relative;
        min-height: 100vh;
        background-color: lightgray;
        scroll-behavior: smooth;
        font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande',
            'Lucida Sans', Arial, sans-serif;
    }

    h1,
    h4 {
        margin-bottom: 0;
    }

    .body-section {
        padding-bottom: 100px;
    }

    @media (max-width: 576px) {
        .body-section {
            padding-bottom: 300px;
        }
        h1 {
            font-size: 1.5rem;
        }
    }

    .dense p {
        margin-bottom: 0;
    }

    .nowrap {
        white-space: nowrap;
    }

    .darkbrown {
        color: var(--darkbrown);
    }

    .lightbrown {
        color: var(--lightbrown);
    }

    .brown {
        color: var(--brown);
    }

    .bg-darkgray {
        background-color: var(--darkgray);
    }

    .bg-darkbrown {
        background-color: var(--darkbrown);
    }
</style>
